import React, { Component } from 'react';
import { CustomLoading, Logging } from './LoadingComponent';
import { connect } from 'react-redux';
import { Label, Input, Button, Form, Alert,
         Card, CardBody, Tooltip,
         ButtonGroup, Modal, ModalHeader, ModalBody } from 'reactstrap';
import { withRouter } from 'react-router-dom';
import { ExcelLink } from "./ExportComponent";
import { aggregate, sort_by, CustomListSelect,
         toPerc, add_perc_key, transpose, mergeByKey, previous_date } from './Functions';
import { portReturns, portSeries, total_ret, avg_ret, vol, mdd } from './analytics';
import { RenderTable, RenderVirtualTable } from './TableComponent';
import { MultBarPlot, MultLineTsPlot,
         StackedBarPlot} from './PlotComponent';
import { postRequest } from '../redux/ActionCreators';
import { Auth } from 'aws-amplify';

const mapStateToProps = state => {
  return {
    user_wm: state.user_wm,
    signature_params: state.signature_params,
    port_metrics_tactical: state.port_metrics_tactical,
  };
};

class PortSignature extends Component {
  constructor(props){
      super(props);
      this.state = {
        load_portfolio:false,
        load_asset:false,
        loading_portfolio:false,
        saving_portfolio:false,
        sending_notif:false,
        loading_series:false,
        adding_asset:false,
        make_changes:false,
        port_id:'Portafolio',
        show_fx:true,
        msg:null,
        msg_save:null,
        msg_asset:null,
        show_indices:true,
        show_products:false,
        exp_alert_tooltip:false,
        risk_alert_tooltip:false
      };
      this.header = this.header.bind(this);
      this.queryPortfolio = this.queryPortfolio.bind(this);
      this.addAsset = this.addAsset.bind(this);
      this.savePortfolio = this.savePortfolio.bind(this);
      this.openSaveModal = this.openSaveModal.bind(this);
      this.openAssetModal = this.openAssetModal.bind(this);
  }
   _isMounted = false;
  
    componentDidMount() {
      this._isMounted = true;
    }
  
    componentWillUnmount() {
      this._isMounted = false;
    }    
    async queryPortfolio(){
      if (this.props.signature_params.port_name==null || this.props.signature_params.port_name=="") {
        this.setState({msg:'Seleccionar portafolio.'});
      } else {
        this.setState({loading_portfolio:true});
        let port_saa;
        let port_limits;
        try {
          const port_saa_temp = await postRequest({
            port_id:this.props.signature_params.port_name, 
            last_update:true,
            res_url:false,
            retrieve_limits:true,
            own_only:this.props.user_wm.data?.role==3 ? true : false,
            port_groups:this.props.user_wm.data?.port_groups
          }, 'port_saa');
          port_limits = port_saa_temp?.limits ? 
            port_saa_temp?.limits.filter(item=>item.Field=="AssetClass").map(item=>{
              return {Clase:item.FieldValue, LI:item.LB*100, LS:item.UB*100};
            }) : null;
          port_saa = [
            {
              ...port_saa_temp.data[0],
              Asset: `Cash ${this.props.signature_params.ref_curr}`,
              Weight: 0
            },
            ...port_saa_temp.data
          ];
        } catch(error) {
          this.setState({
            msg:error.message,
          });
          return;
        }
        try {
          const asset_catalog = await postRequest({
            bucket:'condor-sura', 
            key:'output/asset_data/asset_data_consol.csv', 
            sep:',',
            query_string:`
              SELECT Asset,AssetCategory,AssetClass,SubAssetClass,TickerBenchmark
              FROM s3Object s
              WHERE s."Asset" in ('${port_saa.map(item => item.Asset.replace(/'/g, "\\'")).join("', '")}')
            `,
          }, 'retrieve_data_s3');
          const port_saa_ext = port_saa.map(item => {
            return {...asset_catalog.find(x=>x.Asset==item.Asset), Weight:100*item.Weight, Active:true};
          });
          
          const weights_temp = port_saa.reduce((acc, obj) => {
            acc[asset_catalog.find(x=>x.Asset==obj.Asset).TickerBenchmark] = obj.Weight;
            return acc;
          }, {});

          const initial_ac_temp = aggregate(port_saa_ext, ["AssetClass"], ["Weight"])
              .reduce((acc, item) => {
                acc[item.AssetClass] = item.Weight;
                return acc;
              }, {});

          this.setState({loading_portfolio:false});
          await this.props.changeModel("signature_params", 
                                       {
                                         ...this.props.signature_params, 
                                         weights: weights_temp, 
                                         port: port_saa_ext, 
                                         initial_ac: initial_ac_temp,
                                         limits: port_limits
                                       });
        } catch(error) {
          console.log(error.message);
          this.setState({
            msg:"No hay información disponible en el catálogo de productos. Validar con el equipo de QUANTIM.",
            loading_portfolio:false
          });
          return;
        }
        try {
          this.setState({loading_series:true});
          const series = await postRequest(
            { 
              tks:this.props.signature_params.port.map(x=>x.TickerBenchmark), 
              ref_curr:this.props.signature_params.ref_curr,
              to_returns:true,
              since_date:previous_date(this.props.signature_params.range),
              rets_period:"monthly"
            }, 'get_series');
          await this.props.changeModel('signature_params.asset_series', series.ts);
          this.setState({loading_series:false});
        } catch (error) {
          console.error('Error getting response:', error);
          this.setState({
            msg: error.message,
            loading_series:false
          });
          return;
        }
      }
    }
    
    openSaveModal(weights_consol){
      if (this.props.signature_params.port_name==null || this.props.signature_params.port_name=="") {
        this.setState({msg:'Seleccionar portafolio.'});
      } else if (this.props.signature_params.port==null) {
        this.setState({msg:'Primero debes cargar información del portafolio.'});
      } else if (weights_consol==null || weights_consol?.map(k=>Math.abs(k.Inicial-k.Actualizado)).reduce((acc, val) => acc + val, 0)<0.001) {
        this.setState({msg:'No se ha modificado el portafolio recomendado.'});
      } else {
        this.setState({load_portfolio:true});
      }
    }

    openAssetModal(){
      if (this.props.signature_params.port==null) {
        this.setState({msg:'Primero debes cargar información del portafolio.'});
      } else {
        this.setState({load_asset:true});
      }
    }

    async savePortfolio(e){
      e.preventDefault();
      const form = e.target;
      if (form.port_name.value==null || form.port_name.value=='') {
        this.setState({msg_save:'Insertar nombre de portafolio.'});
      } else {
        this.setState({saving_portfolio:true});
        let save_port;
        try {
          save_port = await postRequest(
            { 
              ref_date:(new Date()).toISOString().slice(0,10),
              port_name:form.port_name.value,
              weights:this.props.signature_params.port.filter(item=>item.Weight>0).map(item=>{
                return {Asset:item.Asset, Weight:item.Weight/100};
              }),
            }, 'load_portfolio');
          if (save_port.status=="ok"){
            await this.props.addPort(form.port_name.value);
            await this.props.changeModel("signature_params.msg", `Portafolio ${form.port_name.value} guardado en BD.`);
          }
          if (this._isMounted) {
            this.setState({
              saving_portfolio: false,
              msg_save: save_port.msg,
            });
          }
          this.setState({saving_portfolio: false});
        } catch (error) {
          this.setState({
            saving_portfolio:false,
            msg_save: error.message
          });
          return;
        }
        try {
          //Email
          if (this.props.user_wm.data?.depends_on.length>0){
            this.setState({
              sending_notif: true
            });
            
            const userInfo = await Auth.currentUserInfo() //`${(await Auth.currentUserInfo()).username}`;
            const username = `${userInfo.username}`;
  
            const rows = this.props.signature_params.port
              .filter(item => item.Weight > 0)
              .map(item => `
                <tr>
                  <td style="padding:4px 8px; border:1px solid #ccc;">${item.Asset}</td>
                  <td style="padding:4px 8px; border:1px solid #ccc;">${(item.Weight).toFixed(2)}%</td>
                </tr>
              `)
              .join('');
            
            const content = `
              Hola,<br><br>
              Nuevo portafolio creado por usuario ${username}:<br><br>
            
              <table style="border-collapse:collapse; font-family:Arial; font-size:12px;">
                <thead>
                  <tr>
                    <th style="padding:4px 8px; border:1px solid #ccc; text-align:left;">Asset</th>
                    <th style="padding:4px 8px; border:1px solid #ccc; text-align:left;">Weight</th>
                  </tr>
                </thead>
                <tbody>
                  ${rows}
                </tbody>
              </table>
            
              <br><br>
              QUANTIM
            `;
            const send_notif = await postRequest({
              to:[username].concat(this.props.user_wm.data?.depends_on).map(x=>`${x}@surainvestments.com`).join(';'),
              from:'quantim@surainvestments.com',
              subject:"Nuevo portafolio guardado en base de datos",
              content:content
            }, 'sendgrid');
            this.setState({sending_notif: false});
            if (send_notif.status=="ok"){
              this.setState({msg_save: `${save_port?.msg}. Se ha enviado correo de notificación.`});
            }
          }
        } catch (error) {
          this.setState({
            sending_notif:false,
            saving_portfolio:false,
            msg_save: `${save_port?.msg}. No se envía correo de notificación.`
          });
          return
        }
      }
    }
    addAsset = async () => {
      if (this.props.signature_params.add_asset==null || this.props.signature_params.add_asset=='') {
        this.setState({msg_asset:'Seleccionar activo.'});
      } else if (this.props.signature_params.port.filter(item=>item.Active).map(item=>item.Asset).includes(this.props.signature_params.add_asset)) {
        this.setState({msg_asset:'Activo ya hace parte del portafolio o ya ha sido seleccionado.'});
      } else if (this.props.signature_params.port.filter(item=>!item.Active).map(item=>item.Asset).includes(this.props.signature_params.add_asset)) {
        this.setState({
          msg:'Activo incluido nuevamente.',
          load_asset:false
        });
        const newPort = [...this.props.signature_params.port];
        const idx = newPort.findIndex(item => item.Asset === this.props.signature_params.add_asset);
        newPort[idx] = {...newPort[idx], Active:true};
        await this.props.changeModel("signature_params.port", newPort);
      } else {
        this.setState({adding_asset:true});
        let asset_info;
        try {
          asset_info = await postRequest({
            bucket:'condor-sura', 
            prefix:'output/asset_data/asset_data_consol.csv',
            key:'output/asset_data/asset_data_consol.csv', 
            sep:',',
            query_string:`
              SELECT Asset,AssetCategory,AssetClass,SubAssetClass,TickerBenchmark
              FROM s3Object s
              WHERE s."Asset"='${this.props.signature_params.add_asset}'
            `,
          }, 'retrieve_data_s3');
          if (asset_info.length==0){
            this.setState({
              msg_asset:"No se encontró información de activo. Por favor intente de nuevo o verifique es activo con el equipo de QUANTIM.",
              adding_asset:false
            });
            return;
          }
        } catch(error) {
          this.setState({
            msg_asset:error.message,
            adding_asset:false
          });
          return;
        }
        try {
          const asset_series = await postRequest(
            { 
              tks:[asset_info[0].TickerBenchmark],
              ref_curr:this.props.signature_params.ref_curr,
              to_returns:true,
              rets_period:"monthly"
            }, 'get_series');

          if (asset_series?.ts){
            const newPort = [
              this.props.signature_params.port[0],   // keep first
              {...asset_info[0], Weight:0, Active:true},          // insert new at 2nd
              ...this.props.signature_params.port.slice(1) // rest of the array
            ];
            await this.props.changeModel("signature_params.port", newPort);
            await this.props.changeModel("signature_params.asset_series", mergeByKey([this.props.signature_params.asset_series, asset_series.ts], "Date", "inner"));
          }
          this.setState({
            load_asset:false,
            msg:"Activo incluido.",
            adding_asset:false});
        } catch (error) {
          console.error('Error getting response:', error);
          this.setState({
            msg_asset: error.message,
            adding_asset:false
          });
          return;
        }
      }
    };

    
    header(weights_consol){
      if (this.props.user_wm.data) {
        return (
          <>
            <div className="row mt-5 mb-3 justify-content-center">
              <div className="col-md-8">
                <h4>Portafolio a Tu Medida</h4>
              </div>  
            </div>
            <div className='row justify-content-center align-items-end mt-4'>
              <div className='col-4'>
                <CustomListSelect
                  options={this.props.user_wm.data.ports_list}
                  isClearable={true}
                  value={this.props.signature_params.port_name==null ? null : {value:this.props.signature_params.port_name, label:this.props.signature_params.port_name}}
                  onChange={(e)=>this.props.changeModel("signature_params.port_name", e?.value)}
                  itemSize={50}
                  className="basic-single"
                  placeholder="seleccionar portafolio . . ."
                />
              </div>
              <div className='col-2'>
                <CustomListSelect
                  options={["USD", "MXN", "COP", "PEN", "CLP"].map(x=>{
                    return {value:x, label:x};
                  })}
                  isClearable={true}
                  value={this.props.signature_params.ref_curr==null ? null : {value:this.props.signature_params.ref_curr, label:this.props.signature_params.ref_curr}}
                  onChange={(e)=>this.props.changeModel("signature_params.ref_curr", e?.value)}
                  itemSize={50}
                  className="basic-single"
                  placeholder="moneda . . ."
                />
              </div>
              <div className='col-2'>
                <CustomListSelect
                  options={['1Y','3Y','5Y','10Y'].map(x=>{
                    return {value:x, label:x};
                  })}
                  isClearable={true}
                  value={this.props.signature_params.range==null ? null : {value:this.props.signature_params.range, label:this.props.signature_params.range}}
                  onChange={(e)=>this.props.changeModel("signature_params.range", e?.value)}
                  itemSize={50}
                  className="basic-single"
                  placeholder="..."
                />
              </div>
            </div>
            <div className='row justify-content-center align-items-end mt-4'>
              <div className='col-auto'>
                <Button 
                    className="btn-corp"
                    onClick={this.queryPortfolio}>
                    <small>Consultar Portafolio</small>
                </Button>
              </div>  
            </div>
            <div className="row m-5 justify-content-center">
              <div className='col-auto'>
                <Button 
                    className="link-btn-corp"
                    onClick={this.openAssetModal}>
                    <small>Buscar producto&#128269;</small>
                </Button>
              </div>  
              <div className='col-auto'>
                <Button 
                    className="link-btn-corp"
                    onClick={()=>this.openSaveModal(weights_consol)}>
                    <small>Guardar Portafolio {" "}</small>
                    <i className="fa fa-bookmark"></i>
                </Button>
              </div>  
            </div>
          </>
          );
      }else{return null;}
    }

  render() {
      if(this.props.user_wm.isLogging){
        return(
          <div className='container'>
            <div className="row justify-content-center">
                <Logging />
            </div>
          </div>
        );
      }else if(this.state.loading_portfolio){
        return(
          <div className='container'>
            <div className="row m-5 justify-content-center">
                <CustomLoading msg="consultando portafolio" icon="fa-database"/>
            </div>
          </div>
        );
      }else if(this.state.loading_series){
        return(
          <div className='container'>
            <div className="row m-5 justify-content-center">
                <CustomLoading msg="series de activos" icon="fa-database"/>
            </div>
          </div>
        );
      } else if (this.props.signature_params.port==null || this.props.signature_params.port.filter(x=>x.Weight>0).length==0){
          return(
            <div className='container'>
              {this.header(null)}
              <div className="row mt-4 justify-content-center">
                <div className="col-4 m-3">
                  <Alert
                    color='secondary'
                    isOpen={this.state.msg!=='' && this.state.msg!==null} 
                    toggle={()=>this.setState({msg:null})}
                    fade={false}
                    >
                      {this.state.msg}
                  </Alert>
                </div>
              </div>
              <div className="row justify-content-center m-5">
                <h6>No hay datos disponibles.</h6>
              </div>
            </div>
          );
      } else {
        const port_saa_adjust = this.props.signature_params.trades.length==0 ? null :
          add_perc_key(aggregate([...this.props.signature_params.trades, ...this.props.signature_params.port], ['Asset'], ['Weight']), "Weight").map(item=>{
            return {Asset:item.Asset, Weight:item.percentage};
          });

        const port_saa = port_saa_adjust==null ? 
          this.props.signature_params.port.map(item=>{
            return {Asset:item.Asset, Portafolio:item.Weight};
          }).sort(sort_by('Portafolio'))
          : port_saa_adjust.map(item=>{
            return {Asset:item.Asset, Portafolio:this.props.signature_params.port.filter(port=>port.Asset==item.Asset).length==0 ? 0 : this.props.signature_params.port.find(port=>port.Asset==item.Asset).Weight, 
            Ajustado:item.Weight};
          });

        const port_dev = port_saa_adjust==null 
          ? this.props.signature_params.port.map(item=>{
            return {Asset:item.Asset, Delta:0};
          })
          : port_saa_adjust.map(item=>{
            return {Asset:item.Asset, Delta:Math.round((item.Weight - (this.props.signature_params.port.filter(port=>port.Asset==item.Asset).length==0 ? 0 : this.props.signature_params.port.filter(port=>port.Asset==item.Asset)[0].Weight))*10)/10};
          }).sort(sort_by('Delta'));

        const weights = this.props.signature_params.port.reduce((acc, obj) => {
          acc[obj.TickerBenchmark] = obj.Weight/100;
          return acc;
        }, {});
        const port_returns_orig = portReturns(this.props.signature_params.asset_series, this.props.signature_params.weights);
        const port_series_orig = portSeries(port_returns_orig, "Inicial");
        const port_returns_udt = portReturns(this.props.signature_params.asset_series, weights);
        const port_series_udt = portSeries(port_returns_udt, "Actualizado");
        const port_series = port_series_orig==null || port_series_udt==null ? null :
                            port_series_orig.map(row1 => {
                              const row2 = port_series_udt.find(r => r.Date === row1.Date) || {};
                              return { ...row1, ...row2 };
                            });

        const weights_consol = [...new Set(Object.keys(this.props.signature_params.weights).concat(Object.keys(weights)))].map(k=>{
                                  return {name:this.props.signature_params.port.find(i=>i.TickerBenchmark==k).Asset, Inicial:100*this.props.signature_params.weights[k] ?? 0, Actualizado:100*weights[k] ?? 0};
                                }).filter(item=>item.Inicial>0 || item.Actualizado>0).sort(sort_by("Inicial", 'desc'));
        const assets_summ = port_series==null || port_series.length==0 ? null : 
                            transpose([{name:"Inicial", rets:port_returns_orig}, {name:"Actualizado", rets:port_returns_udt}].map(item=>{
                              const rets_temp = item.rets.map(k=>k.PortRet);
                              return {
                                Id:item.name, 
                                'Retorno Total':100*total_ret(port_series.map(x=>x[item.name])),
                                'Retorno Promedio Anual.':100*avg_ret(rets_temp, 12), 
                                'Volatilidad Anual.':100*vol(rets_temp, 12), 
                                'Drawdown':100*mdd(port_series.map(x=>x[item.name])), 
                              }}), "Id", "Métrica");
        const vol_values = assets_summ==null ? null : assets_summ.find(k=>k["Métrica"]=="Volatilidad Anual.");
        const risk_perc_change = 0.2;
        const risk_alert = assets_summ==null ? null :
                           ((vol_values["Actualizado"]-vol_values["Inicial"])/vol_values["Inicial"])>risk_perc_change && (vol_values["Actualizado"]-vol_values["Inicial"])>3;
                      
        const port_cards = this.props.signature_params.port.map((item, i) => {
          if (i !== 0 && !item.Active) return null;
          return (
            <Card className="m-2 position-relative" key={i}>
              {/* X button */}
              {i !== 0 && (
                <button
                  type="button"
                  onClick={() => {
                    // Example: remove asset from port
                    const newPort = [...this.props.signature_params.port];
                    newPort[0] = { ...newPort[0], Weight: newPort[0].Weight + this.props.signature_params.port[i].Weight };
                    newPort[i] = { ...newPort[i], Weight: 0, Active:false };
                    this.props.changeModel("signature_params.port", newPort);
                  }}
                  className="btn btn-sm btn-light"
                  style={{
                    position: "absolute",
                    top: "5px",
                    right: "5px",
                    borderRadius: "80%",
                    padding: "0.25rem 0.45rem",
                    lineHeight: "1",
                  }}
                >
                  <h6>x</h6>
                </button>
              )}
        
              <CardBody>
                <div className="row align-items-baseline m-0">
                  <div className="col-auto p-0 m-0">
                    <h6>{item.Asset} |</h6>
                  </div>
                  <div className="col-auto p-1 mb-1">
                    <p>{item.AssetClass}</p>
                  </div>
                </div>
                <div className="row">
                  <div className="col-9">
                    <Input
                      type="range"
                      min="0"
                      max="100"
                      value={item.Weight}
                      onChange={(e) => {
                        if (i !== 0) {
                          const newPort = [...this.props.signature_params.port];
                          const newValuei = Math.min(
                            Number(e.target.value),
                            newPort[i].Weight + newPort[0].Weight
                          );
                          const newValueCash = Math.max(
                            newPort[0].Weight + (newPort[i].Weight - Number(e.target.value)),
                            0
                          );
                          newPort[i] = { ...newPort[i], Weight: newValuei };
                          newPort[0] = { ...newPort[0], Weight: newValueCash };
                          this.props.changeModel("signature_params.port", newPort);
                        }
                      }}
                      className="slider"
                      step={0.1}
                      style={{ "--val": item.Weight }}
                    />
                  </div>
                  <div className="col-3">
                    <small>{toPerc(item.Weight)}</small>
                  </div>
                </div>
              </CardBody>
            </Card>
          );
        });

        const updated_ac = aggregate(this.props.signature_params.port, ["AssetClass"], ["Weight"])
          .reduce((acc, item) => {
            acc[item.AssetClass] = item.Weight;
            return acc;
          }, {}); 
        
        const exp_alert_class = (updated_ac?.["Renta Variable"] ?? 0) > (
            this.props.signature_params?.limits &&  this.props.signature_params.limits.filter(k=>k.Clase=="Renta Variable").length>0 ? 
            this.props.signature_params.limits.find(x=>x.Clase=="Renta Variable").LS :
            (this.props.signature_params.initial_ac?.["Renta Variable"] ?? 0) + 10
          ) ||
          (updated_ac?.["Renta Fija"] ?? 0) > (
            this.props.signature_params?.limits &&  this.props.signature_params.limits.filter(k=>k.Clase=="Renta Fija").length>0 ? 
            this.props.signature_params.limits.find(x=>x.Clase=="Renta Fija").LS :
            (this.props.signature_params.initial_ac?.["Renta Fija"] ?? 0) + 10
          ) ||
          (updated_ac?.["Money Market"] ?? 0) > (
            this.props.signature_params?.limits &&  this.props.signature_params.limits.filter(k=>k.Clase=="Money Market").length>0 ? 
            this.props.signature_params.limits.find(x=>x.Clase=="Money Market").LS :
            (this.props.signature_params.initial_ac?.["Money Market"] ?? 0) + 10
          ) ? 
          "fa fa-times text-danger" : "fa fa-check text-success";
        
        return (
          <div className="container">
            {this.header(weights_consol)}
            <div className="row m-0 justify-content-center">
              <div className="col-4 m-0">
                <Alert
                  color='secondary'
                  isOpen={this.props.signature_params.msg!==null} 
                  toggle={()=>this.props.changeModel("signature_params.msg", null)}
                  fade={false}
                  >
                    {this.props.signature_params.msg}
                </Alert>
              </div>
            </div>
            <div className="row m-0 justify-content-center">
              <div className="col-4 m-0">
                <Alert
                  color='secondary'
                  isOpen={this.state.msg!=='' && this.state.msg!==null} 
                  toggle={()=>this.setState({msg:null})}
                  fade={false}
                  >
                    {this.state.msg}
                </Alert>
              </div>
            </div>
            <div className="row m-3 justify-content-center">
              <div className='col-3'>
                <ButtonGroup size='sm'>
                  <Button
                    color="dark"
                    outline
                    onClick={() => this.setState({make_changes:!this.state.make_changes})}
                    active={!this.state.make_changes}
                  >
                    Ver allocation
                  </Button>
                  <Button
                    color="dark"
                    outline
                    onClick={() => this.setState({make_changes:!this.state.make_changes})}
                    active={this.state.make_changes}
                  >
                    Hacer ajustes
                  </Button>
                </ButtonGroup>
              </div>
              <div className='col-auto' id="exp_alert">
                <h6>Exposición</h6>
                <i 
                  className={exp_alert_class}
                  style={{ fontSize: "2rem" }}
                ></i>
                <Tooltip
                  className='d-none d-md-block' style={{backgroundColor: 'white', color:'black'}} hideArrow={true} placement="top" 
                  fade={false} isOpen={this.state.exp_alert_tooltip} target="exp_alert" toggle={()=>this.setState({exp_alert_tooltip:!this.state.exp_alert_tooltip})}
                >
                  {this.props.signature_params?.limits ?
                  <RenderTable 
                    data={this.props.signature_params.limits.map(item=>{
                      return {Clase:item.Clase, "Máx":item.LS}
                    }
                    )}
                    toPerc={[false, true]}
                    style="black"
                  />
                  : <p>Se activa cuando cambio en clase de activo es mayor a 10%</p>}
                </Tooltip>
              </div>
              <div className='col-auto' id="risk_alert">
                <h6>Riesgo</h6>
                <i className={risk_alert ? "fa fa-times text-danger" : "fa fa-check text-success"} style={{ fontSize: "2rem" }} style={{ fontSize: "2rem" }}></i>
                <Tooltip
                  className='d-none d-md-block' style={{backgroundColor: 'white', color:'black'}} hideArrow={true} placement="top" 
                  fade={false} isOpen={this.state.risk_alert_tooltip} target="risk_alert" toggle={()=>this.setState({risk_alert_tooltip:!this.state.risk_alert_tooltip})}
                >
                  <p>Se activa cuando la volatilidad se incrementa en 20%</p>
                </Tooltip>

              </div>
            </div>
            <Modal isOpen={this.state.load_portfolio} toggle={()=>this.setState({load_portfolio:!this.state.load_portfolio})}>
              <ModalHeader toggle={()=>this.setState({load_portfolio:!this.state.load_portfolio})}>Guardar Portafolio</ModalHeader>
              <ModalBody>
                <Form onSubmit={this.savePortfolio}>
                  <div className="row m-4 justify-content-center">
                    <div className="col-8 m-1">
                      <Input
                        id='port_name'
                        type='text'
                        placeholder="Nombre..."
                      >
                      </Input>
                    </div>
                  </div>
                  <div className="row m-1 justify-content-center">
                    {this.state.saving_portfolio ?
                      <div className='col-auto'>
                        <CustomLoading msg="guardando portafolio" icon="fa-database"/>
                      </div>
                    : this.state.sending_notif ?
                      <div className='col-auto'>
                        <CustomLoading msg="enviando notificación" icon="fa-email" />
                      </div>
                    : 
                      <div className="col-auto m-1">
                        <Button 
                          type='submit'
                          className="btn-corp">
                            Guardar
                        </Button>
                      </div>
                    }
                  </div>
                  <div className="row mt-4 justify-content-center">
                    <div className="col m-3">
                      <Alert
                        color='secondary'
                        isOpen={this.state.msg_save!=='' && this.state.msg_save!==null} 
                        toggle={()=>this.setState({msg_save:null})}
                        fade={false}
                        >
                          {this.state.msg_save}
                      </Alert>
                    </div>
                  </div>
                </Form>
              </ModalBody>  
            </Modal>
            {/*Asset Modal*/}
            <Modal isOpen={this.state.load_asset} toggle={()=>this.setState({load_asset:!this.state.load_asset})}>
              <ModalHeader toggle={()=>this.setState({load_asset:!this.state.load_asset})}>Buscar Activo</ModalHeader>
              <ModalBody>
                <div className='row m-2 justify-content-center align-items-end'>
                  <div className='col-auto'>
                    <Label check>
                      <Input type="checkbox"
                        checked={this.state.show_indices}
                        onChange={()=>this.setState({show_indices:!this.state.show_indices})}
                        />{' '}
                        Índices
                    </Label>
                  </div>
                  <div className='col-auto'>
                    <Label check>
                      <Input type="checkbox"
                        checked={this.state.show_products}
                        onChange={()=>this.setState({show_products:!this.state.show_products})}
                        />{' '}
                        Fondos/ETF
                    </Label>
                  </div>
                </div>
                <div className="row m-4 justify-content-center">
                  <div className="col-8 m-1">
                    <CustomListSelect
                      options={this.props.user_wm.data.assets.filter(x=>(this.state.show_indices && x.AssetType=="Index") || (this.state.show_products && x.AssetType=="Fund/ETF")).map(x=>{
                                return {value:x.Asset, label:x.Isin=="" ? `${x.Asset} | ${x.Ticker}` : `${x.Asset} | ${x.Isin}`};
                              }).sort(sort_by("label"))}
                      isClearable={true}
                      value={this.props.signature_params.add_asset==null ? null : {value:this.props.signature_params.add_asset, label:this.props.signature_params.add_asset}}
                      onChange={(e)=>this.props.changeModel("signature_params.add_asset", e?.value)}
                      itemSize={50}
                      className="basic-single"
                      placeholder="seleccionar activo . . ."
                      fontSize={12}
                    />
                  </div>
                </div>
                <div className="row m-1 justify-content-center">
                  {this.state.adding_asset ?
                    <div className='col-auto'>
                      <CustomLoading msg="agregando activo" />
                    </div>
                  : 
                    <div className="col-auto m-1">
                      <Button 
                        onClick={this.addAsset}
                        className="btn-corp">
                          Añadir
                      </Button>
                    </div>
                  }
                </div>
                <div className="row mt-4 justify-content-center">
                  <div className="col m-3">
                    <Alert
                      color='secondary'
                      isOpen={this.state.msg_asset!=='' && this.state.msg_asset!==null} 
                      toggle={()=>this.setState({msg_asset:null})}
                      fade={false}
                      >
                        {this.state.msg_asset}
                    </Alert>
                  </div>
                </div>
              </ModalBody>  
            </Modal>

            <div className="row mt-5 justify-content-center">
              <div className="col-6 col-lg-2">
                <StackedBarPlot 
                  data={[
                    {name:"Inicial", ...this.props.signature_params.initial_ac},
                    {name:"Actual", ...updated_ac},
                  ]} 
                  ypercAxis={true}
                  barsize={10}
                  width={200}
                  percTooltip={true}
                  height={700}
                  legend={true}
                />
              </div>
              
              {this.state.make_changes ?
                <div className='col-6 col-lg-5'>
                  <div className="row m-0">
                    <div className='col-12' style={{ paddingRight:'30px'}}>
                      {port_cards[0]}
                    </div>
                  </div>
                  <div className="row m-0">
                    <div className='col-12' style={{ overflowY: 'auto', maxHeight: '500px'}}>
                      {port_cards.slice(1)}
                    </div>
                  </div>
                </div>
                :
                <div className='col-6 col-lg-5'>
                  <div className="row mt-5 justify-content-center">
                    <div className='col'>
                      <MultBarPlot 
                        data={weights_consol}
                        nameKey="name"
                        vertical={true}
                        angle={0}
                        ytype="category" 
                        xtype="number"
                        colors={['#000000',"#1215E3"]}
                        xpercAxis={true}
                        percTooltip={true}
                        interval={0}
                        height={500}
                        width={450}
                        barsize={5}
                        legend={true}
                        fontsize={12}
                      />
                    </div>
                  </div>
                </div>
              }              
              {port_series ?
              <div className='col-6 col-lg-5'>
                <div className="row mt-3 justify-content-center">
                  <div className='col-auto'>
                    <MultLineTsPlot data={port_series}
                     width={400}
                     height={300}
                     xkey='Date'
                     ykeys={["Inicial", "Actualizado"]}
                     xtype='category'
                     ytype='number'
                     colors = {['#000000',"#1215E3"]}
                     percTooltip={true}
                     ml={30}
                     legend={true}
                   />
                  </div>
                </div>
                <div className="row mt-5 justify-content-center">
                  <div className='col-auto'>
                    <h6 className="m-0">Métricas</h6>
                    <RenderVirtualTable 
                      data={assets_summ} 
                      to_perc={[false, true, true]}
                      cell_width={["150px", '100px', '100px']}
                      item_size={40}
                      paddingRight="0px"
                      style="black"
                      />
                  </div>
                </div>
              </div>
              :null                
              }
            </div>
            <div className="row mt-2 justify-content-center">
              <div className="col-auto">
                <ExcelLink class_name='link-btn' data={weights_consol} label="descargar portafolio" filename="portafolio.xlsx"/>
              </div>
            </div>

          </div>
        );
      }
    }
}
//export default Port;
export default withRouter(connect(mapStateToProps)(PortSignature));